import { useApi } from "./useApi";
import {
  WelcomeBookApi,
  savePaymentUrl,
  saveReservationTransactionLogUrl,
} from "../utils/constants";
import { useMutation, useQuery } from "@tanstack/react-query";

const useWelcomeBook = () => {
  const { apiPrivate } = useApi();

  /* ------------------------------ getOwners ----------------------------- */
  const getWelcomeBook = async (reservationId: string) => {
    const response: { data: any } = await apiPrivate.get(
      WelcomeBookApi + `?reservationId=${reservationId}`
    );
    return response;
  };

  const savePayment = async (data: any) => {
    const response: { data: any } = await apiPrivate.post(savePaymentUrl, {
      id: data?.id,
      status: data?.status,
      description: data?.description,
    });
    return response;
  };

  const saveReservationTransactionLog = async (reservationId: string) => {
    const response: { data: any } = await apiPrivate.post(
      saveReservationTransactionLogUrl + reservationId,
      {}
    );
    return response;
  };

  const GetWelcomeBookQuery = (reservationId: string) =>
    useQuery({
      queryKey: [WelcomeBookApi, reservationId],
      queryFn: () => getWelcomeBook(reservationId),
    });

  const SaveReservationTransactionLogMutation = () =>
    useMutation({
      mutationFn: (reservationId: string) =>
        saveReservationTransactionLog(reservationId),
      onSuccess: () => {},
    });

  return {
    GetWelcomeBookQuery,
    savePayment,
    SaveReservationTransactionLogMutation,
  };
};
export { useWelcomeBook };
